import React from 'react'
import Popover from '@mui/material/Popover'
import { FxInfoProps } from './FxInfo.props'

/**
 *
 * @param header
 * @param content
 * @constructor
 */
export const FxInfo = ({ header, content }: FxInfoProps) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  /**
   *
   * @param event
   */
  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  /**
   *
   */
  const handlePopoverClose = () => setAnchorEl(null)

  /**
   *
   */
  const renderPopover = () =>
    <Popover
      id="mouse-over-popover"
      sx={{
        pointerEvents: 'none',
      }}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus>
      <div className="fx-info">
        {header &&
          <div className="tooltip-header">{header}</div>
        }
        <div className="tooltip-content">{content}</div>
      </div>
    </Popover>

  return (
    <>
      <span
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}>
        <i className="fas fa-info-circle" />
      </span>
      {renderPopover()}
    </>
  )
}
